import React from 'react';
import { useLazyQuery } from '@apollo/client';
import { Button, Icon } from 'anf-core-react';
import TmntText from '../Common/Text/TmntText';
import { resendOrderButtonProps, resendOrderButtonDefaultProps } from './props';
import { RESEND_ORDER_CONFIRMATION_QUERY } from './operations';
import ButtonState from '../Common/ButtonState/ButtonState';

export default function ResendOrderConfirmationButton({ resendOrder }) {
  const {
    buttonText,
    processing,
    error,
    success,
    number,
  } = resendOrder;

  const [fetchResendOrderConfirmation] = useLazyQuery(RESEND_ORDER_CONFIRMATION_QUERY, {
    fetchPolicy: 'network-only',
  });

  // Default values for isShipping and packgeNumber are passed based on current CRS implementation
  // This component will be updated accordingly if there are any changes for In-Store Orders
  const handleOnSubmit = () => new Promise((resolve, reject) => {
    try {
      fetchResendOrderConfirmation({
        variables: {
          orderId: number,
          isShipping: false,
          packageNumber: '',
        },
      });

      resolve();
    } catch {
      reject();
    }
  });

  return (
    <ButtonState
      asyncOnClick={handleOnSubmit}
      success={(
        <Button variant="tertiary-light" isDisabled isFullWidth>
          <Icon icon="check" />
          <TmntText tmnt={success} />
        </Button>
      )}
      error={(
        <Button variant="tertiary-light" isFullWidth type="button">
          <TmntText tmnt={error} />
        </Button>
      )}
      processing={(
        <Button variant="tertiary-light" isProcessing isDisabled isFullWidth>
          <TmntText tmnt={processing} />
        </Button>
      )}
      initial={(
        <Button variant="tertiary-light" isFullWidth type="button">
          <TmntText tmnt={buttonText} />
        </Button>
      )}
    />
  );
}

ResendOrderConfirmationButton.propTypes = {
  resendOrder: resendOrderButtonProps,
};

ResendOrderConfirmationButton.defaultProps = {
  resendOrder: resendOrderButtonDefaultProps,
};
